<!--
    * 胜率预测 bar
    * 尺寸太小的图看不全120分钟因为宽度不够刻度展示不全
-->

<template>
  <div
    class="winRatePrediction_bar"
    :class="isAutoExportPng ? 'autoExportPng' : ''"
  >
    <div class="tip_container" v-if="isTipFlag && tipList.length > 0">
      <div class="tipDiv_row">
        <span
          class="tipItem"
          v-for="(item, index) in tipList"
          :key="index"
          v-text="_valPerFormatHandler(item)"
        ></span>
      </div>
    </div>
    <div class="barEcharts">
      <div
        ref="barEcharts"
        class="barEchartsDom"
        :style="{
          height: `${parentDomHPx ? parentDomHPx : 'auto'}`,
        }"
        @click="clickEchartBox"
      ></div>
    </div>
  </div>
</template>

<script>
// 胜率预测 bar
import cup_base_data_mixin from '@mixins/cup_base_data'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'winRatePrediction_bar',
  mixins: [canvasToImage_base64_data_mixin, cup_base_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
    isTipFlag: {
      //是否显示提示信息
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      homeBgColor: ['rgba(235, 27, 80, 1)', 'rgba(235, 27, 80, 1)'], //主队：【坐标轴颜色，柱状条颜色】
      awayBgColor: ['rgb(0, 207, 183, 1)', 'rgb(0, 207, 183, 1)'], //客队：【坐标轴颜色，柱状条颜色】
      otherColor: [
        'rgba(255,255,255,1)',
        'rgba(255,255,255,1)',
        'rgba(0,0,0,1)',
      ], //[分钟刻度字颜色，平局颜色,Y轴字体颜色]
      initFlag: false,
      resizeFlag: false,
      tipList: [],
      myChart: null,
      yAxisMax: 100,
      maxMinTime: 90, //比赛最大分钟
      homeData: [],
      awayData: [],
      xAxisTimeInterval: 5, //时间轴 分割值
      parentDomHPx: null,
      xAixstextBgIcon:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAACkAgMAAADKwbkWAAAACVBMVEUAAAAAAAAAAACDY+nAAAAAAnRSTlMAf7YpoZUAAADjSURBVFjD7c6xEcJADERRSBRQAtXQDqpGJRCQ6KrE47mxbOvuJzBE2vQF+y8/3pP52h7o0gz93t7o2pzvGwbI4ob3DQN0ccd7DJDVje4xQFd3uMcA6W5wTwHa3eEeAmRzm91jgG7uk3sMkJ3b+B4DdOc+vMcAObiN7jFAD+58nwPk5JbvMUBP7ukeAyS5pXsK0OSe7iFABm54HwFxnwPiHgNk6La/xwAduvN9BMjELe4xQCfucU8BMnWLewjQqXu/xwABt35PAQru/R4CBN0uN/RXeXl5eXl5eXl5eXn53/zLfQBxDTJH1ZLrgAAAAABJRU5ErkJggg==',
    }
  },
  created() {},
  mounted() {
    // this.initData() //本地测试数据
    this.isInitEChart()
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myChart) {
      window.removeEventListener('resize', this.onResizeEvent)
      this.myChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.homeData = []
    this.awayData = []
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('newVal:', newVal)
        const dataList = newVal.data ? newVal.data : []
        const legendData = dataList.legendData ? dataList.legendData[0] : {}
        const homeName = legendData.homeName ? legendData.homeName : ''
        const awayName = legendData.awayName ? legendData.awayName : ''
        const homeWinPer = legendData.homeWinPer ? legendData.homeWinPer : 0
        const awayWinPer = legendData.awayWinPer ? legendData.awayWinPer : 0
        let drawPer = legendData.drawPct ? legendData.drawPct : 0
        if (homeWinPer == 0 && awayWinPer == 0) {
          drawPer = 0
        }
        const tipList = []
        tipList.push({
          title: homeName,
          val: homeWinPer,
        })
        tipList.push({
          title: homeName ? '平局' : '',
          val: drawPer,
        })
        tipList.push({
          title: awayName,
          val: awayWinPer,
        })
        this.tipList = tipList
        this.homeData =
          dataList.homeList && dataList.homeList.length > 0
            ? dataList.homeList
            : []
        this.awayData =
          dataList.awayList && dataList.awayList.length > 0
            ? dataList.awayList
            : []
        if (
          this.maxMinTime == 90 &&
          (this.homeData.length > 18 || this.awayData.lengh > 18)
        ) {
          this.maxMinTime = 120
        }
        if (this.initFlag) {
          this.initEcharts()
          if (!this.resizeFlag) {
            this.resizeFlag = false
            this.myChart.resize()
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    // initData() {
    //   this.homeData = [0, 20, 40, 30, 10, 60, 30, 40, 10, 30, 40, 50, 60]
    //   this.awayData = [10, 20, 30, 50, 70, 30, 30, 40, 70, 50, 40, 30, 20]
    // },
    isInitEChart() {
      this.setTimeoutId = setTimeout(() => {
        if (this.$refs.barEcharts && this.$refs.barEcharts.clientWidth) {
          clearTimeout(this.setTimeoutId)
          this.parentDomHPx = `${Math.ceil(
            this.$refs.barEcharts.clientWidth / 2.233
          )}px`
          this.$nextTick(() => {
            this.initEcharts()
            this.initFlag = true
            this.myChart.on('click', 'series.line', (params) => {
              console.debug(params)
              if (params.componentType == 'markPoint') {
                // 点击了 markPoint
                this.isMarkFlag = true
              }
            })
            window.addEventListener('resize', this.onResizeEvent)
          })
        } else {
          this.isInitEChart()
        }
      }, 50)
    },
    onResizeEvent() {
      this.myChart.resize()
    },
    clickEchartBox(e) {
      console.debug(e)
      if (!this.isMarkFlag) {
        // 清空关键事件
        console.debug('清空关键事件')
      }
      this.isMarkFlag = false
    },
    initEcharts() {
      const clientWidth = this.$refs.barEcharts.clientWidth
      const fontSize = Math.round((10 / 375) * clientWidth)
      const arrowSize = Math.round((4 / 375) * clientWidth)
      const maxMinTime = this.maxMinTime
      const xAxisTimeSeriesData = []
      let leftWidth = Math.round(0.004 * clientWidth)
      // console.debug('dpi:', dpi, leftWidth * dpi)
      for (let i = 5; i <= maxMinTime; i = i + this.xAxisTimeInterval) {
        xAxisTimeSeriesData.push({
          value: `${i}`,
          textStyle: {
            fontSize: Math.ceil(fontSize * 0.6),
            color: this.otherColor[0],
            backgroundColor: {
              image: this.xAixstextBgIcon,
            },
            fontWeight: 'bold',
            fontFamily: 'Qatar2022',
            padding: [
              Math.ceil(fontSize * 0.75),
              0,
              Math.ceil(fontSize * 0.25),
              0,
            ],
            width: Math.ceil(fontSize * 1.2),
          },
        })
      }

      let option = {
        title: {
          show: false,
          text: '胜率预测',
        },
        animation: !this.isAutoExportPng,
        tooltip: {
          show: false,
        },
        grid: {
          top: '5%',
          bottm: '10%',
          left: '6.5%',
          right: '6.5%',
          width: '87%',
          height: '85%',
        },
        legend: {
          show: false,
        },
        color: [this.awayBgColor[1], this.homeBgColor[1]],
        xAxis: {
          type: 'category',
          offset: -Math.ceil(fontSize * 0.25),
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          data: xAxisTimeSeriesData,
        },
        yAxis: [
          {
            type: 'value',
            max: 100,
            axisLabel: {
              show: true,
              fontSize,
              color: this.otherColor[2],
              formatter: function (value, index) {
                return (value / 100).toFixed(1)
              },
              fontWeight: 'bold',
              fontFamily: 'Qatar2022',
              opacity: 1,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              symbol: ['none', 'arrow'],
              onZeroAxisIndex: 0,
              symbolSize: [arrowSize, arrowSize],
              symbolOffset: [0, arrowSize],
              lineStyle: {
                width: leftWidth, //(dpi*leftWidth).toFixed(1)
                color: this.awayBgColor[0],
                cap: 'square',
              },
            },
          },
          {
            type: 'value',
            max: 100,
            inverse: true,
            axisLabel: {
              show: true,
              fontSize,
              color: this.otherColor[2],
              formatter: function (value, index) {
                return (value / 100).toFixed(1)
              },
              fontWeight: 'bold',
              fontFamily: 'Qatar2022',
              opacity: 1,
            },
            splitLine: {
              show: false,
            },
          },
          {
            offset: 0,
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: true,
              symbol: ['arrow', 'none'],
              symbolSize: [arrowSize, arrowSize],
              symbolOffset: [arrowSize * -1, 20],
              lineStyle: {
                width: leftWidth,
                color: this.homeBgColor[0],
                cap: 'square',
              },
            },
          },
        ],
        series: [
          {
            name: '客队',
            type: 'bar',
            yAxisIndex: 0,
            showBackground: true,
            backgroundStyle: {
              color: this.otherColor[1],
              opacity: 1,
            },
            barCategoryGap: '16%',
            symbol: 'none',
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
            data: this.awayData,
          },
          {
            name: '主队',
            type: 'bar',
            yAxisIndex: 1,
            // xAxisIndex: 2,
            barGap: '-100%',
            backgroundStyle: {
              color: this.homeBgColor[1],
              opacity: 1,
            },
            barCategoryGap: '16%',
            symbol: 'none',
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
            data: this.homeData,
          },
        ],
      }
      if (!this.myChart) {
        this.myChart = this.$echarts.init(this.$refs.barEcharts)
      }
      this.myChart.setOption(option)

      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(
            this.$refs.barEcharts,
            true,
            'uploadData',
            this.datas.data.legendData
          )
        }, 5 * 1000)
      }
    },
    _valPerFormatHandler(item) {
      let data
      let val = item.val
      let ceil = '%'
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = 0
        ceil = ''
      }
      data = `${item.title} ${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.winRatePrediction_bar {
  position: relative;
  width: 80%;
  height: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  border: 0.416vw solid rgba(235, 235, 235, 1);
  border-radius: 0.694vw;
  background-color: rgba(235, 235, 235, 1);
  &.autoExportPng {
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 0;
    background-color: transparent;
  }
  .barEcharts {
    width: 100%;
    height: 100%;
    .barEchartsDom {
      height: 100%;
      width: 100%;
    }
  }
  .tip_container {
    position: absolute;
    top: -2.083vw;
    left: 0;
    z-index: 200;
    width: 100%;
    height: auto;
    .tipDiv_row {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items: center;
      font-size: 0.972vw;
      color: var(--mixtmt_greyColor_main);
    }
  }
}
</style>
